import { gql } from "@apollo/client";

export const TOP_PLAYERS_LIFETIME = gql`
    query TopPlayersLifetime($limit: Int = 50, $offset: Int = 0) {
        topPlayersLifetime(limit: $limit, offset: $offset) {
            playerId
            playerName
            clanTag
            value
            shield {
                imageUrl
                imageWithTagsUrl
            }
            clanColor
        }
    }
`;

export const TOP_PLAYERS_CURRENT_SEASON = gql`
    query TopPlayersCurrentSeason($limit: Int = 50, $offset: Int = 0) {
        topPlayersCurrentSeason(limit: $limit, offset: $offset) {
            playerId
            playerName
            clanTag
            value
            shield {
                imageUrl
                imageWithTagsUrl
            }
            clanColor
        }
    }
`;

export const TOP_PLAYERS_PREVIOUS_SEASON = gql`
    query TopPlayersPreviousSeason(
        $seasonId: UUID!
        $limit: Int = 50
        $offset: Int = 0
    ) {
        topPlayersPreviousSeason(
            seasonId: $seasonId
            limit: $limit
            offset: $offset
        ) {
            playerId
            playerName
            clanTag
            value
            shield {
                imageUrl
                imageWithTagsUrl
            }
            clanColor
        }
    }
`;

export const TOP_PLAYERS_BY_CLAN = gql`
    query TopPlayersByClanGrouped(
        $seasonId: UUID!
        $clanOffsets: GenericScalar
        $limit: Int = 50
    ) {
        topPlayersByClanGrouped(
            seasonId: $seasonId
            clanOffsets: $clanOffsets
            limit: $limit
        ) {
            clanTag
            players {
                playerId
                playerName
                clanTag
                value
                shield {
                    imageUrl
                    imageWithTagsUrl
                }
                clanColor
            }
        }
    }
`;

export const TOP_PLAYERS_SHIELD_VALUE = gql`
    query TopPlayersShieldValue($limit: Int = 50, $offset: Int = 0) {
        topPlayersShieldValue(limit: $limit, offset: $offset) {
            playerId
            playerName
            clanTag
            value
            shield {
                imageUrl
                imageWithTagsUrl
            }
            clanColor
        }
    }
`;

export const ALL_SEASONS = gql`
    query AllSeasons {
        allSeasons {
            id
            name
            isActive
        }
    }
`;

export const ALL_CLANS = gql`
    query AllClans {
        allClans {
            id
            name
            tag
        }
    }
`;

export const CLAN_STANDINGS_CURRENT_SEASON = gql`
    query ClanStandingsCurrentSeason {
        clanStandingsCurrentSeason {
            clanName
            clanTag
            points
        }
    }
`;
